// extracted by mini-css-extract-plugin
export var alertIcon = "_sk-0";